export default function initpartner(){
    //TODO: ?Kann Modularisiert werden. Nur auf Seite Partner relevant
    var defaultsrc = $(".partner-tabs img.lazy:first").attr("default-src");
    $(".partner-tabs img.lazy").each(function () {
        $.ajax({
            context: this,
            url: $(this).attr("src"),
            statusCode: {
                404: function () {
                    $(this).attr("src", defaultsrc);
                }
            }
        });
    });

    $(".partner-tabs .tab-link").on("click", function () {
        $(".partner").hide();

        setTimeout(function () {
            $(".partner").responsiveEqualHeightGrid();
            $(".partner").show();
        }, 50);
    });

    //TODO: Kann modularisiert werden: Nur auf partnner benötigt
    var currentTitleObject = $("#Alphas").closest(".alphabet-tabs").find(".module-hdl h1")
    var currentTitle = currentTitleObject.text();

    // Set the selected letter on ready
    currentTitleObject.text(currentTitle + " mit " + $(".tab-link.hasresult.selected").first().text());

    //hiding tab content except first one
    $(".alphabet-tabs .tab-section").not(":first").hide();
    $(".alphabet-tabs .tab-link:first").addClass("selected");

    // Click event on tab
    $(".alphabet-tabs .tab-link").on("click",function () {
        // Add letter to title
        if ($(this).hasClass("hasresult")) {
            currentTitleObject.text(currentTitle + " mit " + $(this).text());
        }

        // Removing class of Active tab
        $(".alphabet-tabs .tab-link").each(function (index) {
            $(".alphabet-tabs .tab-link").removeClass("selected");
        });


        // Adding Active class to Clicked tab
        $(this).addClass("selected");
        // hiding all the tab contents
        $(".alphabet-tabs .tab-section").hide();
        // showing the clicked tab's content

        $('.alphabet-tabs .tabbed-content').find($(this).attr("href")).show();
        $('.alphabet-tabs .element').responsiveEqualHeightGrid();
        return false;
    });

    $(".partner").responsiveEqualHeightGrid();
}